import { render, staticRenderFns } from "./CarryForward.vue?vue&type=template&id=9509e3d0&scoped=true"
import script from "./CarryForward.vue?vue&type=script&lang=js"
export * from "./CarryForward.vue?vue&type=script&lang=js"
import style0 from "./CarryForward.vue?vue&type=style&index=0&id=9509e3d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9509e3d0",
  null
  
)

export default component.exports